import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Clock, Zap } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { DEMO_QUOTES } from "../data/demo";
import { StatusPill, Eyebrow } from "../components/Bits";

export default function Services() {
  const { t } = useLang();
  const nav = useNavigate();
  const cols = t("services.cols");
  return (
    <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-14" data-testid="services-page">
      <StatusPill status="beta" />
      <h1 className="font-display text-4xl sm:text-5xl text-white mt-3">{t("services.title")}</h1>
      <p className="text-white/60 mt-3 max-w-2xl">{t("services.sub")}</p>

      <div className="glass rounded-2xl overflow-hidden mt-10">
        <div className="grid grid-cols-12 px-5 py-3 text-[11px] uppercase tracking-wider text-white/40 border-b border-white/10">
          <div className="col-span-4">{cols[0]}</div><div className="col-span-2">{cols[1]}</div>
          <div className="col-span-2">{cols[2]}</div><div className="col-span-2">{cols[3]}</div>
          <div className="col-span-2 text-right">{cols[4]}</div>
        </div>
        {DEMO_QUOTES.map((q, i) => (
          <div key={q.name} data-testid={`quote-row-${i}`} className="grid grid-cols-12 items-center px-5 py-4 border-b border-white/5 hover:bg-white/[0.02] transition-colors duration-200">
            <div className="col-span-4">
              <div className="text-white text-sm flex items-center gap-2">{q.name} <ShieldCheck size={13} className="text-emerald-400" /></div>
              <div className="text-white/40 text-xs">{t("common.verified")} {q.score} · {q.warranty}</div>
            </div>
            <div className="col-span-2 text-gold font-semibold text-sm">{q.price}</div>
            <div className="col-span-2 text-white/70 text-xs flex items-center gap-1"><Clock size={12} />{q.availability}</div>
            <div className="col-span-2 text-white/70 text-xs flex items-center gap-1"><Zap size={12} className="text-gold" />{q.response}</div>
            <div className="col-span-2 text-right">
              <button onClick={() => nav("/ask", { state: { prompt: `Book ${q.name} for AC repair tonight` } })}
                className="text-xs px-3 py-1.5 rounded-lg bg-gold/15 text-gold border border-gold/20 hover:bg-gold/25 transition-colors duration-200">{t("common.select")}</button>
            </div>
          </div>
        ))}
        <div className="px-5 py-3 text-[11px] text-gold/70">{t("services.note")}</div>
      </div>

      <h2 className="font-display text-2xl text-white mt-14 mb-5">{t("services.flow_h")}</h2>
      <div className="grid md:grid-cols-4 gap-4">
        {t("services.flow").map((s, i) => (
          <div key={i} className="rounded-2xl bg-surface/60 border border-white/[0.06] p-5">
            <div className="w-8 h-8 rounded-full bg-gold/10 text-gold flex items-center justify-center font-display">{i + 1}</div>
            <p className="text-white/60 text-sm mt-3">{s}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
